import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EventsCarousel from "./component/EventsCarousel";
import RootCause from "./component/RootCause";
import PreventiveAction from "./component/PreventiveAction";
import Header from "./component/Header";
import html2pdf from "html2pdf.js";
import { API_URL } from "configs";
import { redirectToIncidentList } from "actions";
import Resolution from "pages/Overview/component/IncidentForm/component/FinalReportTab/component/Resolution/Resolution";

const IncidentView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const incidentState = useSelector((state) => state.incidentState);
  const session = useSelector((state) => state.session);
  const reportRef = useRef(null);

  const [isFinalReportGenerated, setIsFinalReportGenerated] = useState(false);
  const [incidentRec, setIncidentRec] = useState([]);

  console.log("incidentState in view page", incidentRec);

  useEffect(() => {
    if (!incidentState.incidentRecord) return;

    setIncidentRec(incidentState.incidentRecord);
    if (incidentState.incidentRecord.status === "final_report") {
      setIsFinalReportGenerated(true);
    }
  }, [incidentState.incidentRecord]);

  // Check if the update form needs to be shown
  useEffect(() => {
    if (incidentState.redirect_to_list) {
      navigate("/incidentInitiation");
    }
  }, [incidentState.redirect_to_list]);

  useEffect(() => {
    if (!incidentState.showViewPage && !incidentState.showUpdateForm) {
      navigate("/incidentInitiation");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentState.showViewPage, incidentState.showUpdateForm]);

  const downloadPDF = () => {
    const element = reportRef.current;
    if (!element) return;

    const options = {
      margin: 0.5,
      filename: "Final_Report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(element).set(options).save();
  };

  const downloadPDFReport = (e, record_id) => {
    var token = localStorage.getItem("token");
    window.location.href =
      API_URL +
      "incident/downloadPDFReport?id=" +
      record_id +
      "&token=" +
      token;
  };

  return (
    <>
      <Header />
      <div className="p-4">
        <div className="final-report-content" ref={reportRef}>
          <div className="final-report-content mb-3">
            <h2 className="font-18 font-weight-bold heading-color mb-2">
              Severity:
            </h2>
            <Row>
              <Col lg={4}>
                <div>
                  <h2 className="font-13 font-weight-bold heading-color">
                    Here is the Title
                  </h2>
                  <p className="font-13 font-weight-normal text-color">
                    <img
                      src="/assets/images/critical-circle.svg"
                      className="me-2"
                      alt=""
                    />
                    {incidentRec.severity_level_name || ""}
                  </p>
                </div>
              </Col>

              <Col lg={4}>
                <div>
                  <h2 className="font-13 font-weight-bold heading-color mb-2">
                    Scope:
                  </h2>
                  <p className="font-13 font-weight-normal text-color mb-1">
                    {(incidentRec.scopes || [])
                      .map((scope) => scope.opt_display ?? scope.name)
                      .join(", ")}
                  </p>
                </div>
              </Col>
              <Col lg={4}>
                <div>
                  <h2 className="font-13 font-weight-bold heading-color">
                    Description:
                  </h2>
                  <p
                    className="font-13 font-weight-normal text-color"
                    dangerouslySetInnerHTML={{
                      __html:
                        incidentRec.initiation_description ||
                        "<i>No description</i>",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div className="final-report-content mb-3">
            <EventsCarousel previousData={incidentRec} />
          </div>
          <div>
            <Resolution resolutions={incidentRec?.resolutions} />
          </div>
          <div>
            <RootCause rootCauses={incidentRec?.root_causes} />
          </div>
          <div>
            <PreventiveAction
              prevention_actions={incidentRec?.prevention_actions}
            />
          </div>
        </div>

        <div className="d-flex justify-content-start gap-3 m-3">
          <button
            className="c-b-btn"
            onClick={() => {
              dispatch(redirectToIncidentList());
            }}
          >
            Cancel
          </button>

          <button
            className="n-u-btn"
            onClick={(e) => downloadPDFReport(e, incidentRec?.id)}
            // onClick={downloadPDF}
          >
            Download PDF
          </button>
        </div>
      </div>
    </>
  );
};

export default IncidentView;
